import "./locales/i18n";
import "simplebar-react/dist/simplebar.min.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "react-quill/dist/quill.snow.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { createRoot } from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

// Unregister any stale service workers (e.g. from old CRA builds) that
// may cache outdated assets and cause a blank screen in Chrome.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
